import { throttle } from 'lodash-es';
import type { RefObject } from 'react';
import { useEffect, useState } from 'react';

export const useMousePosition = (ref?: RefObject<HTMLElement | null>) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const updatePosition = (event: Event) => {
      const mouseEvent = event as MouseEvent;
      setPosition({
        x: mouseEvent.clientX + window.scrollX,
        y: mouseEvent.clientY + window.scrollY,
      });
    };

    const throttledUpdatePosition = throttle(updatePosition, 25);

    const element = ref?.current ?? window;
    element.addEventListener('mousemove', throttledUpdatePosition);
    return () =>
      element.removeEventListener('mousemove', throttledUpdatePosition);
  }, [ref]);

  return position;
};
